/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Ballot_ErrorInputs */

const vi_tea_purchase_ballot_error = /** @type {(inputs: Tea_Purchase_Ballot_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đánh dấu trả phiếu thất bại`)
};

/**

* @param {Tea_Purchase_Ballot_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_ballot_error = /** @type {((inputs?: Tea_Purchase_Ballot_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Ballot_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_ballot_error(inputs)
});